
export class ModelContract<Stores, Events, Effects, OverridesForTests> {
    constructor(
        public stores: Stores,
        public events: Events,
        public effects: Effects,
        public __overridesForTests: OverridesForTests,
    ) { }
}

export class ModuleDescription<TContract extends ModelContract<any, any, any, any>> {
    constructor() { }

    getDefaultContract(): TContract {
        return new ModelContract({}, {}, {}, {}) as any;
    }

    getContract(): TContract {
        return this.getDefaultContract();
    }

    run() { }
}

export class ModulesGroup {
    constructor(public modules: ModuleDescription<any>[]) { }

    overrideByType(typeModule: Function, newModule: ModuleDescription<any>) {
        const idx = this.modules.findIndex((m) => m instanceof typeModule);
        if (idx !== -1) {
            this.modules[idx] = newModule;
        }
    }

    getByType<T>(typeModule: Function): T {
        const m: T = this.modules.find((m) => m instanceof typeModule) as T;
        if (!m) {
            throw new Error(`Module ${typeModule.name} not found`);
        }

        return m;
    }

    run() {
        this.modules.forEach((m) => m.run());
    }
}
